import axios from 'axios';

// ACTION TYPES
const name = 'data';
export const actionTypes = {
  STRATEGIES: `${name}:strategies`,
};

// ACTIONS
export function loadPersonalStrategies() {
  return (dispatch, getState) => {
    const request = {
      method: 'GET',
      url: `${getState().params.apiUrl}/personalstrategies/`,
      params: {
        clientEmail: getState().params.clientEmail,
      },
      headers: {
        Authorization: getState().params.token && `Token ${getState().params.token}`,
      },
    };
    return axios(request)
      .then((response) => {
        dispatch({ type: actionTypes.STRATEGIES, value: response.data });
      })
      .catch((error) => {
        console.error(error);
      });
  };
}
